export enum AppENV {
  prod = 'prod',
  development = 'development',
  test = 'test',
}

export function enableByEnv(env: string[]): boolean {
  return (env as string[]).includes(window.env.APP_ENVIRONMENT.split('-')[0])
}

export const dateFormat = 'MM/dd/yyyy'
